// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    addLabor,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    deleteLabor
} from './labor';
import {
    addPart,
    changePartProperty,
    changePartsUnit,
    deletePart
} from './parts';
import {
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    createOtherCredit,
    deleteOtherCredit
} from './other-credits';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    resetSpaClaim,
    resetSpaFieldsForUptimeClaim,
    resetSpaProductDetails,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateSpaClaimCalculationProperty,
    updateSpaClaimFailureDate,
    updateSpaClaimFailurePart,
    updateSpaClaimInputOnBlur,
    updateSpaClaimPin,
    updateSpaClaimProperty,
    updateSpaClaimRepairDate,
    updateSpaClaimRepairNumber,
    updateSpaClaimType,
    updateSpaClaimUnitDropDown,
    updateSpaClaimUseAmount,
    updateSpaClaimWorkOrderOne,
    updateSpaClaimWorkOrderTwo,
    updateStickyHeaderVisibility
} from './claim-details';
import {
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updateSpaClaimBasisForSettlement,
    updateSpaClaimComplaintCause,
    updateSpaClaimComplaintCorrection,
    updateSpaClaimDtacCase,
    updateSpaClaimDtacSolution,
    updateSpaClaimFailedArea,
    updateSpaClaimFailedModeComments,
    updateSpaClaimOperatorComments,
    updateSpaClaimOperatorsComplaint,
    updateSpaClaimPartSerialNumber
} from './failure-panel';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createSpaClaim} from './validate-claim';
import {onEditClaim} from '../../shared/action-creators/edit-claim';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readDownTime} from '../../shared/action-creators/down-time';
import {readFailureModes} from './failure-modes';
import {readGoodsInstallationVatOptions} from '../../shared/action-creators/get-goods-installation-vat-options';
import {readLaborLocations} from '../../shared/action-creators/labor-locations';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {readOtherCreditDescriptions} from '../../shared/action-creators/other-credit-descriptions';
import {readOwnershipStatuses} from '../../shared/action-creators/ownership-status';
import {readPartDetails} from './get-part-details';
import {readSpaClaim} from './get-spa-claim';
import {readSpaTypes} from './get-spa-types';
import {resetCkcCustomerFailure} from '../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import {toggleWarrentyStatusModal} from '../../shared/action-creators/warranty-status-modal';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../product/details/action-creators/warranties';

export default {
    addFile,
    addLabor,
    addPart,
    additionalRepair,
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    changePartProperty,
    changePartsUnit,
    copyAttachments,
    copyClaim,
    createOtherCredit,
    createSpaClaim,
    deleteFile,
    deleteLabor,
    deleteOtherCredit,
    deletePart,
    onCreateClaim,
    onEditClaim,
    readClaimProduct,
    readClaimTypes,
    readDownTime,
    readFailureModes,
    readGoodsInstallationVatOptions,
    readLaborLocations,
    readLaborTypes,
    readOtherCreditDescriptions,
    readOwnershipStatuses,
    readPartDetails,
    readSpaClaim,
    readSpaTypes,
    resetCkcCustomerFailure,
    resetConfirmationModal,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    resetSpaClaim,
    resetSpaFieldsForUptimeClaim,
    resetSpaProductDetails,
    setConfirmationModal,
    toggleWarrentyStatusModal,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updateGoodsInstallationVat,
    updateIsEditable,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateSpaClaimBasisForSettlement,
    updateSpaClaimCalculationProperty,
    updateSpaClaimComplaintCause,
    updateSpaClaimComplaintCorrection,
    updateSpaClaimDtacCase,
    updateSpaClaimDtacSolution,
    updateSpaClaimFailedArea,
    updateSpaClaimFailedModeComments,
    updateSpaClaimFailureDate,
    updateSpaClaimFailurePart,
    updateSpaClaimInputOnBlur,
    updateSpaClaimOperatorComments,
    updateSpaClaimOperatorsComplaint,
    updateSpaClaimPartSerialNumber,
    updateSpaClaimPin,
    updateSpaClaimProperty,
    updateSpaClaimRepairDate,
    updateSpaClaimRepairNumber,
    updateSpaClaimType,
    updateSpaClaimUnitDropDown,
    updateSpaClaimUseAmount,
    updateSpaClaimWorkOrderOne,
    updateSpaClaimWorkOrderTwo,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateWarranties
};



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/index.js